
import DesignContentLayout from '@/layouts/design/DesignContentLayout';

export default {
  name: 'DesignGetStartedPrinciples',
  components: { DesignContentLayout }
};
